import Repository from './Repository';
import TranslationsRequests from '@/models/Localization/TranslationsRequest';
import ListRequest from '@/models/ListRequest';
import { LocalizationLanguage } from '@/models/Localization/LocalizationLanguage';

const resource = '/localization';

export default {
  listTranslations(listRequest: ListRequest) {
    return Repository.post(`${resource}/listTranslations`, listRequest, {withCredentials: true});
  },
  getTranslations(translationsRequest: TranslationsRequests) {
    return Repository.post(`${resource}/getTranslations`, translationsRequest, {withCredentials: true});
  },
  createLocalizationLanguage(name: string){
    return Repository.post(`${resource}/createLocalizationLanguage`, {name}, {withCredentials: true});
  },
  getLanguages(){
    return Repository.get(`${resource}/getLanguages`, {withCredentials: true});
  },
  getCategories(){
    return Repository.get(`${resource}/getCategories`, {withCredentials: true});
  },
  getCollections(categoryId: number|undefined){
    return Repository.get(`${resource}/getCollections?categoryId=${categoryId}`, {withCredentials: true});
  },
  createLocalizationCategory(Name: string){
    return Repository.post(`${resource}/createLocalizationCategory`, {Name}, {withCredentials: true});
  },
  createLocalizationCollection(model: any){
    return Repository.post(`${resource}/createLocalizationCollection`, model, {withCredentials: true});
  },
  createTranslation(model: any){
    return Repository.post(`${resource}/createTranslation`, model, {withCredentials: true});
  },
  deleteLocalizationKeys(LocalizationKeyIds: number[]){
    return Repository.post(`${resource}/deleteLocalizationKeys`, {LocalizationKeyIds}, {withCredentials: true});
  },
  updateTranslation(model: any){
    return Repository.post(`${resource}/updateTranslation`, model, {withCredentials: true});
  },
  getAvailableLanguagesForAdding(){
    return Repository.get<void, LocalizationLanguage[]>(`${resource}/getAvailableLanguagesForAdding`, {withCredentials: true});
  },
};